import axios from 'axios';
import { BASE_API_URL } from '@/constants';

const entityName = 'service-regionals';

export default class ServiceRegionalService {
  /**
   * Retrieve all SR (Regional services)
   */
  public retrieveAll(): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .get(BASE_API_URL + entityName)
        .then(res => {
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  }
}
